import React from "react";
import { Row, Container, Button, Progress, Col } from "reactstrap";
import MissionsCardRight from "./rightSideTiles";
import getConfig from "next/config";

const config = getConfig().publicRuntimeConfig;

// function shuffleMissions(missions) {
//   let i = missions.length - 1;
//   for (; i > 0; i--) {
//     const j = Math.floor(Math.random() * (i + 1));
//     const temp = missions[i];
//     missions[i] = missions[j];
//     missions[j] = temp;
//   }
//   return missions;
// }
class MissionsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      missionsData: [],
    };
  }

  render() {
    const { missions, title } = this.props;

    // const missionss = shuffleMissions(missions);
    // const missionRandom = Math.floor(Math.random() * 5) + 1;

    return (
      <Container className="hide-for-mobile">
        <Row style={{}}>
          <Col
            lg="6"
            md="6"
            sm="12"
            xs="12"
            className="p-0"
            style={{ borderRight: "1px solid #dddddd"  }}
          >
            <div style={{ padding: "2rem 3rem 3rem 2rem" }}>
              <h3 style={{ fontSize: "1rem" }}>FEATURED MISSIONS</h3>
              <img
                src={`${config.cdnUrl}${missions[0].image.imgUrlPath}${missions[0].image.imgUrl}`}
                alt={missions[0].image.imgAlt}
                style={{ width: "100%" }}
              />
              <p style={{ paddingTop: "1rem" }}>
                <b>{missions[0].name}</b>
              </p>
              <p>{missions[0].description}</p>
              <br></br>{" "}
              <Progress
                className="supporter-process-bar"
                value={missions[0].stats.percentage_reached}
              />
              <br />
              <a
                href={`/missions/${missions[0].slug}`}
                onClick={() => {
                  if (window.eventDispatcher) {
                    window.eventDispatcher.dispatchEventSync(
                      "missions-card-btn-dektop-left",
                      {},
                      { amplitude: true }
                    );
                  }
                }}
              >
                <Button
                  color="primary"
                  className="btn-full-width btn  btn-primary"
                >
                  <img
                    className="give-now-button-icon"
                    src={`${config.cdnUrl}/static/icons/heart-donation-programs-page.svg`}
                    alt="Hearts"
                  />
                  {missions[0].buttonText}
                </Button>
              </a>
            </div>
          </Col>
          <Col lg="6" md="6" sm="12" xs="12" className="p-0">
            <div style={{ padding: "2rem 2rem 3rem 3rem" }}>
              <h3 style={{ fontSize: "1rem" }}>OTHER MISSIONS YOU CAN SUPPORT</h3>
              {missions.slice(1, missions.length + 1).map((mission, indexm) => (
                <MissionsCardRight key={indexm} mission={mission} />
              ))}
            </div>
            
          </Col>
        </Row>
      </Container>
    );
  }
}

export default MissionsCard;


